import Flickity from 'flickity';

class ProductSteps {
  constructor() {
    this.carouselNav();
  }

  carouselNav() {
    const carousel = document.querySelector('.main-carousel');
    const navCarousel = document.querySelector('.main-carousel-nav');
    let navSteps = navCarousel.querySelectorAll('.nav-step');

    const selectors = {
      tab: '[role="tab"]',
      panelWrapper: '.main-carousel-nav',
      panel: '[role="tabpanel"]',
    };

    const classes = {
      tabActive: 'button-active',
      panelActive: 'panel-active',
    };

    // Creates an array from the querySelectorAll nodeslist
    let navItems = [...navCarousel.querySelectorAll('.nav-step p')];

    // Parse JSON settings from the section liquid
    const settings = JSON.parse(carousel.dataset.options);

    if (carousel) {
      let flckty = new Flickity('.main-carousel', settings);

      navCarousel.addEventListener('click', (event) => {
        if (!matchesSelector(event.target, '.nav-step p')) {
          return;
        }

        let index = navItems.indexOf(event.target);
        flckty.selectCell(index);
      });
      
      // Function that uses .matches() to check the eventListener target against the selector to make sure they match.
      function matchesSelector(el, selector) {
        let p = Element.prototype;
        let f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
          return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };
        return f.call(el, selector);
      }

      navSteps.forEach((element, index) => {
        element.addEventListener('click', (event) => {

          this.querySelectorAll(`${selectors.panel}:not(#${panelId})`).forEach((inactivePanel) => {
            inactivePanel.tabindex = -1;
            inactivePanel.classList.remove('active');
          });

          // this.querySelectorAll(selectors.tab).forEach((tab) => {
          //   tab.addEventListener('click', (evt) => {
          //     const panelId = tab.getAttribute('aria-controls');
          //     const tabId = tab.getAttribute('id');
          //     const event = new CustomEvent('panel:switch', {
          //       detail: {
          //         panelId,
          //       },
          //       bubbles: true,
          //       composed: true,
          //     });
          //     evt.target.dispatchEvent(event);
          //     const newPanelHeight = this.getElementById(panelId).clientHeight;
          //     this.querySelector(selectors.panelWrapper).style.height = `${newPanelHeight}px`;
          //     const tabItemWidth = tab.clientWidth;
          //     const tabItemPosition = tab.offsetLeft;
          //     root.style.setProperty('--tab-bar-position', `${tabItemPosition}px`);
          //     root.style.setProperty('--tab-bar-width', `${tabItemWidth}px`);
          //     tab.classList.add('button-active');
          //     tab.setAttribute('aria-selected', 'true');
          //     this.querySelectorAll(`${selectors.tab}:not(#${tabId})`).forEach((inactiveTab) => {
          //       inactiveTab.classList.remove('button-active');
          //       inactiveTab.setAttribute('aria-selected', 'false');
          //     });
          //   });
          // });
        });
      });
    }
  }
}

export default ProductSteps;